import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useNotifications } from "@/context/NotificationsContext";
import { PushPin } from "@phosphor-icons/react";

export default function News() {
    const [news, setNews] = useState([]);
    const { markNewsRead } = useNotifications();

    useEffect(() => {
        (async () => {
            try {
                const { data } = await api.get("/news");
                setNews(data);
                markNewsRead();
            } catch (e) {
                if (process.env.NODE_ENV !== "production") {
                    console.warn("news load failed:", e);
                }
            }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="space-y-6" data-testid="news-page">
            <div>
                <div className="text-[10px] uppercase tracking-[0.22em] text-muted-foreground">
                    Aggiornamenti società
                </div>
                <h1 className="font-display text-4xl md:text-5xl font-black uppercase tracking-tight">
                    News
                </h1>
            </div>
            <div className="space-y-4">
                {news.map((n) => (
                    <article
                        key={n.id}
                        className="rounded-2xl hairline bg-card overflow-hidden"
                    >
                        {n.image_url && (
                            <div
                                className="h-40 md:h-56 bg-muted bg-cover bg-center"
                                style={{ backgroundImage: `url(${n.image_url})` }}
                            />
                        )}
                        <div className="p-5">
                            <div className="flex items-center gap-2 text-[10px] uppercase tracking-[0.22em] text-muted-foreground">
                                {n.pinned && (
                                    <span className="inline-flex items-center gap-1 text-primary">
                                        <PushPin size={12} weight="fill" /> In evidenza
                                    </span>
                                )}
                                <span>{n.author || "Società"}</span>
                                <span>·</span>
                                <span>{new Date(n.created_at).toLocaleDateString("it-IT")}</span>
                            </div>
                            <h2 className="font-display text-2xl md:text-3xl font-bold uppercase tracking-tight mt-1">
                                {n.title}
                            </h2>
                            <p className="mt-3 text-sm leading-relaxed whitespace-pre-line text-foreground/90">
                                {n.body}
                            </p>
                        </div>
                    </article>
                ))}
                {news.length === 0 && (
                    <div className="rounded-2xl hairline p-8 text-center bg-card">
                        <div className="text-muted-foreground">Nessuna news pubblicata.</div>
                    </div>
                )}
            </div>
        </div>
    );
}
